import React from 'react';

export default function Home() {
  return (
    <div className="max-w-2xl mx-auto p-6 mt-12">
      <div className="bg-white rounded-lg shadow-lg p-8 text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Jobsite Safety Assessment System
        </h1>
        <p className="text-gray-600 mb-6">
          This system automatically creates safety assessment forms for your Jobber jobs.
        </p>
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-left">
          <h2 className="font-semibold text-blue-900 mb-2">How it works:</h2>
          <ol className="space-y-2 text-sm text-blue-800">
            <li>1. When a new job is created in Jobber, a unique safety form link is automatically generated</li>
            <li>2. The link is added to the job's custom field</li>
            <li>3. Crew members open the link to complete the safety assessment</li>
            <li>4. The completed assessment PDF is attached to the job in Jobber</li>
          </ol>
        </div>
      </div>
    </div>
  );
}